import { Navigate } from 'react-router-dom'
import { useProductMode } from '../contexts/ProductModeContext'
import { WorkspaceShellSkeleton } from './Skeleton'

interface StudentHumanLayerRouteProps {
  children: React.ReactNode
}

/** Blocks student human-tutor routes when platform is in AI-only mode. */
const StudentHumanLayerRoute = ({ children }: StudentHumanLayerRouteProps) => {
  const { humanTutorLayerEnabled, loading } = useProductMode()

  if (loading) {
    return <WorkspaceShellSkeleton />
  }

  if (!humanTutorLayerEnabled) {
    return <Navigate to="/messages" replace />
  }

  return <>{children}</>
}

export default StudentHumanLayerRoute
